import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

export const UnvalidatedStyles = {
  reactionPickerBottomMargin: 40,
  senderImageSize: 40,
  senderImageMarginRight: 6,
};

export const Styles = StyleSheet.create({
  // TODO(fant): move these super small paddings to MBView
  /*
    smallPaddingTop: { paddingTop: 5 },
    smallPaddingBottom: { paddingBottom: 5 },
    smallPaddingHorizontal: { paddingHorizontal: 5 },
    //*/
  smallMarginTop: { marginTop: 5 },

  alignRight: { alignItems: 'flex-end' },
  justifyRight: { justifyContent: 'flex-end' },
  bubbleMaxWidth: { maxWidth: '75%' }, // controls width of all chat bubbles
  semitransparent: { opacity: 0.5 },
  rowAlignRight: {
    width: '100%',
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  rowAlignLeft: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  flex: { flex: 1 },
  deliveryStatus: {
    flex: 1,
    alignSelf: 'flex-end',
  },

  messageBubble: {
    // Note: same border radius as MBLinkPreview
    // TODO(fant): there seems to be a bug with react-native-web
    // where borderRadius sometimes overrides border{Direction}Radius
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    minHeight: UnvalidatedStyles.senderImageSize,
    justifyContent: 'center',
  },

  messageBubbleContent: {
    paddingVertical: 8,
    paddingHorizontal: 14,
  },
  // prevent the nested text inside MBFormattedText from overflowing
  maxWidth: { maxWidth: '100%' },

  userImage: {
    width: UnvalidatedStyles.senderImageSize,
    height: UnvalidatedStyles.senderImageSize,
    borderRadius: UnvalidatedStyles.senderImageSize / 2,
    overflow: 'hidden',
    alignSelf: 'flex-end',
    marginRight: UnvalidatedStyles.senderImageMarginRight,
  },
  userImagePlaceholder: {
    width: UnvalidatedStyles.senderImageSize + UnvalidatedStyles.senderImageMarginRight,
  },

  // Border radius to make link preview (with its border) fit with the
  // message bubble's border. Note: this might be overriden by
  // meMessageBubbleGroupedWithBelow/otherUserMessageBubbleGroupedWithBelow
  linkPreviewBorderRadius: {
    overflow: 'hidden',
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    borderRadius: 0,
  },

  // only small border radius when grouped
  smallTopRightBorderRadius: { borderTopRightRadius: 4 },
  smallBottomRightBorderRadius: { borderBottomRightRadius: 4 },

  // only small obrder radius when grouped
  smallTopLeftBorderRadius: { borderTopLeftRadius: 4 },
  smallBottomLeftBorderRadius: { borderBottomLeftRadius: 4 },
});

const me: MBMessageBubbleTheme = {
  backgroundColor: Colors.v2.green10,
  // Note(fant): textColor and highlightColor aren't used by web
  textColor: Colors.v2.greenSecondary90,
  highlightColor: Colors.v2.greenSecondary90,
  align: 'right',
  showImage: false,
  isDM: false,
  isEditing: false,
};

const other: MBMessageBubbleTheme = {
  backgroundColor: Colors.gray.touch,
  textColor: Colors.v2.purple,
  highlightColor: Colors.v2.purple,
  align: 'left',
  showImage: true,
  isDM: false,
  isEditing: false,
};

const dm: Partial<MBMessageBubbleTheme> = { isDM: true };
const edit: Partial<MBMessageBubbleTheme> = {
  isEditing: true,
  backgroundColor: Colors.v2.green10,
};

const meSelected: MBMessageBubbleTheme = {
  ...me,
  blinkBackgroundColor: Colors.v2.green30,
};
const otherSelected: MBMessageBubbleTheme = {
  ...other,
  blinkBackgroundColor: Colors.v2.gray10,
};

export const MBMessageBubbleTheme = {
  me,
  other,
  meSelected,
  otherSelected,

  meDM: { ...me, ...dm } as MBMessageBubbleTheme,
  otherDM: { ...other, ...dm } as MBMessageBubbleTheme,
  meSelectedDM: { ...meSelected, ...dm } as MBMessageBubbleTheme,
  otherSelectedDM: { ...otherSelected, ...dm } as MBMessageBubbleTheme,

  edit: { ...me, ...edit } as MBMessageBubbleTheme,
  editDM: { ...me, ...edit, ...dm } as MBMessageBubbleTheme,

  get: getTheme,
};

interface GetThemeProps {
  me: boolean;
  dm: boolean;
  editing: boolean;
  selected: boolean;
}

function getTheme(props: GetThemeProps): MBMessageBubbleTheme | undefined {
  if (props.me) {
    return getMeTheme(props);
  } else {
    return getOtherTheme(props);
  }
}

function getMeTheme(props: GetThemeProps): MBMessageBubbleTheme | undefined {
  // ME and DM
  if (props.dm && props.editing) {
    return MBMessageBubbleTheme.editDM;
  }
  if (props.dm && props.selected) {
    return MBMessageBubbleTheme.meSelectedDM;
  }
  if (props.dm && !props.selected) {
    return MBMessageBubbleTheme.meDM;
  }

  // ME and !DM
  if (!props.dm && props.editing) {
    return MBMessageBubbleTheme.edit;
  }
  if (!props.dm && props.selected) {
    return MBMessageBubbleTheme.meSelected;
  }
  if (!props.dm && !props.selected) {
    return MBMessageBubbleTheme.me;
  }
}

function getOtherTheme(props: GetThemeProps): MBMessageBubbleTheme | undefined {
  // !ME and DM
  if (props.dm && props.selected) {
    return MBMessageBubbleTheme.otherSelectedDM;
  }
  if (props.dm && !props.selected) {
    return MBMessageBubbleTheme.otherDM;
  }

  // !ME and !DM
  if (!props.dm && props.selected) {
    return MBMessageBubbleTheme.otherSelected;
  }
  if (!props.dm && !props.selected) {
    return MBMessageBubbleTheme.other;
  }
}
